// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__sq4dv","message":"styles_message__X3rNR","details":"styles_details___XV55"};